import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const PriceConfigEditModal = ({ priceConfig, setPriceConfig, onEditSuccess }) => {
  const [profitPercent, setProfitPercent] = useState("");
  const [serviceFeePercent, setServiceFeePercent] = useState("");
  const [saving, setSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // Populate state when priceConfig changes
  useEffect(() => {
    if (priceConfig) {
      setProfitPercent(priceConfig.profitPercent !== undefined ? priceConfig.profitPercent.toString() : "");
      setServiceFeePercent(priceConfig.serviceFeePercent !== undefined ? priceConfig.serviceFeePercent.toString() : "");
      setErrorMsg("");
    }
  }, [priceConfig]);

  const handleClose = () => {
    setPriceConfig(null);
    setErrorMsg("");
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!priceConfig?.docId) return;

    const profitVal = parseFloat(profitPercent);
    const serviceFeeVal = parseFloat(serviceFeePercent);

    if (isNaN(profitVal) || profitVal < 0) {
      setErrorMsg("❌ Profit % must be a number greater than or equal to 0.");
      return;
    }

    if (isNaN(serviceFeeVal) || serviceFeeVal < 0) {
      setErrorMsg("❌ Service Fee must be a number greater than or equal to 0.");
      return;
    }

    try {
      setSaving(true);
      setErrorMsg("");

      //const docRef = doc(db, "price_config", priceConfig.currencyCode);
      const docRef = doc(db, "price_config", priceConfig.docId);
      await updateDoc(docRef, {
        profitPercent: profitVal,
        serviceFeePercent: serviceFeeVal,
        updatedAt: serverTimestamp(),
      });

      if (onEditSuccess) {
        onEditSuccess();
      }
      handleClose();
    } catch (error) {
      console.error("Error updating price config:", error);
      setErrorMsg("❌ Failed to update price configuration. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={!!priceConfig} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Price Configuration</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSave}>
        <Modal.Body>
          {errorMsg && (
            <div className="alert alert-danger py-2 rounded-3 small" role="alert">
              {errorMsg}
            </div>
          )}

          {/* Currency Code (Read-Only) */}
          <Form.Group className="mb-3" controlId="editCurrencyCode">
            <Form.Label className="fw-semibold text-dark">Currency Code</Form.Label>
            <Form.Control
              type="text"
              value={priceConfig?.currencyCode || ""}
              disabled
              readOnly
            />
          </Form.Group>

          {/* Country Code (Read-Only) */}
          {/* <Form.Group className="mb-3" controlId="editCountryCode">
            <Form.Label className="fw-semibold text-dark">Country Code</Form.Label>
            <Form.Control
              type="text"
              value={priceConfig?.countryCode || ""}
              disabled
              readOnly
            />
          </Form.Group> */}

          {/* Profit Percent */}
          <Form.Group className="mb-3" controlId="editProfitPercent">
            <Form.Label className="fw-semibold text-dark">Profit %</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              value={profitPercent}
              onChange={(e) => setProfitPercent(e.target.value)}
              required
              disabled={saving}
              placeholder="e.g. 7.00"
            />
          </Form.Group>

          {/* Service Fee  */}
          <Form.Group className="mb-3" controlId="editServiceFeePercent">
            <Form.Label className="fw-semibold text-dark">Fixed Service Fee</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              value={serviceFeePercent}
              onChange={(e) => setServiceFeePercent(e.target.value)}
              required
              disabled={saving}
              placeholder="e.g. 0.50"
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={saving}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving ? (
              <>
                <span
                  className="admin-loader-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Updating...
              </>
            ) : (
              "Update"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default PriceConfigEditModal;
